import React from "react";
import { CircularProgress } from "@material-ui/core";
import styles from './styles.module.css';
import classNames from 'classnames';

export default React.memo((props) =>
  <div className={classNames(styles.root, props.className)}>
    <CircularProgress />
  </div>,
);

